<template lang="html">
    <div class="side-content side1" :class="sidestate">
          <div class="side-inner">
                <div :class="['side-line',{'untap':disArrs[0]}]" @click="goInner(1)">
                      <div class="line-name">音乐分类</div>
                      <div class="lin-icon">
                           <span v-if="selectedArr[0].length>0">+{{selectedArr[0].length}}</span>
                           <van-icon class="icon" class-prefix="iconfont" name="more" />
                      </div>
                </div>
                <div :class="['side-line',{'untap':disArrs[1]}]" @click="goInner(2)">
                      <div class="line-name">创作信息</div>
                      <div class="lin-icon">
                           <span v-if="selectedArr[1].length>0">+{{selectedArr[1].length}}</span>
                           <van-icon class="icon" class-prefix="iconfont" name="more" />
                      </div>
                </div>
                <div :class="['side-line',{'untap':disArrs[2]}]" @click="goInner(3)">
                      <div class="line-name">主题词</div>
                      <div class="lin-icon">
                           <span v-if="selectedArr[2].length>0">+{{selectedArr[2].length}}</span>
                           <van-icon class="icon" class-prefix="iconfont" name="more" />
                      </div>
                </div>
                <div :class="['side-line',{'untap':disArrs[3]}]" @click="goInner(4)">
                      <div class="line-name">出版者</div>
                      <div class="lin-icon">
                           <span v-if="selectedArr[3].length>0">+{{selectedArr[3].length}}</span>
                           <van-icon class="icon" class-prefix="iconfont" name="more" />
                      </div>
                </div>
                <div :class="['side-line',{'untap':disArrs[4]}]" @click="goInner(5)">
                      <div class="line-name">出版年代</div>
                      <div class="lin-icon">
                           <span v-if="selectedArr[4].length>0">+{{selectedArr[4].length}}</span>
                           <van-icon class="icon" class-prefix="iconfont" name="more" />
                      </div>
                </div>
                <!-- <div class="side-block">
                      <div class="block-ttl">
                           <div class="ttl-name">出版者</div>
                           <div class="block-selected"></div>
                      </div>
                      <div class="block-content">
                            <div class="select-item ellipsis"
                                 v-for="(item,index) in preDat[0].publishList"
                                 :key="index">
                                    {{item}}
                            </div>
                      </div>
                </div>
                <div class="side-block">
                      <div class="block-ttl">
                           <div class="ttl-name">出版年代</div>
                           <div class="block-selected"></div>
                      </div>
                      <div class="block-content">
                           <div class="select-item ellipsis"
                                 v-for="(item,index) in preDat[0].publishYearList"
                                 :key="index">
                                    {{item}}
                           </div>
                      </div>
                </div> -->
                <div :class="['foot-line',{'untap':!cleanbtn}]">
                      <div class="foot-btn" @click="cleanSelect">
                          <van-icon class="icon" class-prefix="iconfont" name="removeAll" />
                          <span>清除选项</span>
                      </div>
                </div>
          </div>
          <div class="side-btns">
                 <div class="s-btn" @click="sideClose">取消</div>
                 <div class="s-btn" @click="goSeek">确认</div>
          </div>
    </div>
</template>

<script>
export default {
   props:['inDat','selectedArr'],
   watch:{
       inDat:function(e){
            if(e){
                 for(let i = 0;i < this.disArrs.length;i++){
                     this.disArrs.splice(i,1,this.empFirm(i+1,e));
                 }
            }
       },
       selectedArr:function(e){
            this.cleanbtn = false;
            for(let i = 0;i < e.length;i++){
               if(e[i].length > 0){
                    this.cleanbtn = true;
                    break;
               }
            }
       }
   },
   data(){
       return{
            sidestate:'',
            disArrs:['true','true','true','true','true'],
            cleanbtn:false
       }
   },
   methods:{
       sideOpen:function(){
           this.sidestate = 'act';
       },
       sideClose:function(){
           this.sidestate = 'hide';
           this.$emit('modelClose');
       },
       empFirm:function(type,inDat){
           let empC = true;
           if(type == 1){
               for(let i = 0;i < inDat.classifyList.length;i++){
                    if(inDat.classifyList[i].classifyList.length > 0){
                        empC = false;
                        break;
                    }
               }
           }else if(type == 2){
               let keyMap = {
                   celebrityLyricList:'词作家',
                   composerList:'曲作家',
                   musicArrangementList:'编曲',
                   changeArrangementList:'改编',
                   singerList:'演唱',
                   accompanySingerList:'伴唱',
                   directList:'指挥',
                   renditionList:'演奏',
                   renditionInstrumentList:'演奏乐器'
               };
               for(let key in keyMap){
                   if(inDat[key].length > 0){
                       empC = false;
                       break;
                   }
               }
           }else if(type == 3){
               for(let i = 0;i < inDat.thematicWordsList.length;i++){
                    if(inDat.thematicWordsList[i].classifyList.length > 0){
                        empC = false;
                        break;
                    }
               }
           }else if(type == 4){
               if(inDat.publishList.length > 0){
                   empC = false;
               }

           }else if(type == 5){
               if(inDat.publishYearList.length > 0){
                   empC = false;
               }
           }
           return empC;
       },
       goInner:function(intype){
           this.$emit('transMove',{
                intype
           });
       },
       goSeek:function(){
           this.$emit('goSeek');
           this.sideClose();
       },
       cleanSelect:function(){
           this.$emit('cleanSelect');
       }
   }
}
</script>

<style lang="css" scoped>

.side-content{
    width: 325px;
    height: 100%;
    position: absolute;
    background: white;
    top: 0px;
    right: -325px;
    transform: translate3d(0,0,0);
}

.side-content .side-inner{
    position: absolute;
    left: 0;
    right: 0;
    width: 325px;
    height: 587px;
    overflow: scroll;
}

.side-content.act{
    transition-duration: 0.3s;
    transition-delay: 0.2s;
    transition-timing-function: ease-in-out;
    transition-property: all;
    transform: translate3d(-325px,0,0);
}

.side-content.hide{
    transition-duration: 0.3s;
    transition-timing-function: ease-in-out;
    transition-property: all;
    transform: translate3d(0,0,0);
}

.side-content{
    padding-top: 30px;
}

/* 分类 */

.side1 .side-line{
    margin-left: 10px;
    display: flex;
    height: 45px;
    align-items: center;
    border-bottom: 1px solid #efefef;
    justify-content: space-between;
}

.side1 .side-line.untap{
    opacity: 0.3;
    pointer-events: none;
}

.side1 .lin-icon span{
    font-size: 14px;
    display: inline-block;
    vertical-align: middle;
}

.side1 .lin-icon .icon{
    font-size: 24px;
    color: #999999;
    vertical-align: middle;
}

/* 出版者、出版年代 */

.side1 .side-block{
    border-bottom: 1px solid #efefef;
}

.side1 .block-ttl{
    height: 45px;
    display: flex;
    align-items: center;
    margin: 0 10px;
    justify-content: space-between;
}

.side1 .block-ttl .block-selected{
    font-size: 14px;
}

.side1 .select-item{
    font-size: 13px;
    width: 82px;
    color: #666666;
    text-align: center;
    box-sizing: border-box;
    padding: 6px 15px;
    background: #efefef;
    display: inline-block;
    margin: 0 12px;
    margin-bottom: 15px;
    border-radius: 24px;
}

/* 选择清除 */

.side1 .foot-line{
    height: 45px;
    text-align: right;
    line-height: 45px;
    margin-right: 10px;
}

.side1 .foot-line.untap{
    pointer-events: none;
    opacity: 0.5;
}

.side1 .foot-line .foot-btn{
   display: inline-block;
}

.side1 .foot-line .foot-btn span{
   margin-left: 3px;
   font-size: 14px;
   color: #999999;
}

/* 底部却认按钮 */

.side1 .side-btns{
    position: absolute;
    z-index: 2;
    left: 0px;
    bottom: 30px;
    display: flex;
    height: 50px;
    width: 100%;
    background: salmon;
}

.side1 .side-btns .s-btn{
    height: 50px;
    flex-grow: 1;
    background: #efefef;
    color: #666666;
    text-align: center;
    line-height: 50px;
}

.side1 .side-btns .s-btn:first-child{
    border-right: 1px solid #ebe4e4;
}

.side1 .side-btns .s-btn:last-child{
    border-left: 1px solid #ebe4e4;
    background: #af2d2d;
    color: white;
}

</style>
